export enum EVolumeType{
    Seismic2D = 0,
    Seismic3D = 1,
}